module.exports = __webpack_public_path__ + "static/img/map1230.47a800e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map1230.jpg
// module id = W0W9
// module chunks = 0